import React from 'react';
import { Link } from 'react-router-dom';
import '../../../styles/teachering/layout/mainFooter.css';

const MainFooter = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-legal">
          <div className="footer-brand">
            <h3>플랙티컬 주식회사</h3>
            <p>대표: 강연구 | 사업자등록번호: 853-81-03114 | 통신판매업신고번호: 2024-충남천안-0144호</p>
            <p>주소: 충청남도 천안시 서북구 백석로 277 (성정동) 에콜로지 301-74호 | 전화: 02-949-9158 | 이메일: teachering.edu@gmail.com</p>
            <p>© 2025 플랙티컬 All Rights Reserved</p>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-content">
            <Link to="/help-center/privacy-policy">개인정보처리방침</Link>
            <Link to="/help-center/terms-of-service">이용약관</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MainFooter; 